import { createNamespace } from './base'

const send = createNamespace('/api/auth-v2')

const Auth = {    
    LogInConfirmByLink: (data) => send({ action: 'confirm-link', data: { ...data }, type: 'post' }),
    LogInRepeatLink: (data) => send({ action: 'repeat-confirm', data: { ...data }, type: 'post' }),
    LogInRequest: (data) => send({ action: 'log-in-request', data: { ...data }, type: 'post' }),
    LogInConfirm: (data) => send({ action: 'log-in-confirm', data: { ...data }, type: 'post' }),

    AuthorizationByToken: ({ token }) => send({ action: `authorization-by-token?key=${token}` }),

    /*Соцсети*/
    GetSocialUrl: (data) => send({ action: `get-social-url`, data: { ...data }, type: 'post' }),
    GetSocialAuthData: (data) => send({ action: `get-social-auth-data`, data: { ...data } }),
}

export default Auth